import {
  setServiceUid,
  publicInstance,
  loginInstance,
  privateInstance,
} from "./index";
const qs = require("qs");

export const generatePhoneCert = async (params) => {
  const serviceUid = await setServiceUid();
  try {
    return await publicInstance().post(
      `service/${serviceUid}/member/generate-phone-cert`,
      qs.stringify(params)
    );
  } catch (error) {
    console.error(error);
  }
};
export const checkPhoneCert = async (params) => {
  const serviceUid = await setServiceUid();
  try {
    return await publicInstance().post(
      `service/${serviceUid}/member/check-phone-cert`,
      qs.stringify(params)
    );
  } catch (error) {
    console.error(error);
  }
};

export const signUp = async (params) => {
  const serviceUid = await setServiceUid();
  try {
    return await publicInstance().post(
      `service/${serviceUid}/member/signup`,
      params
    );
  } catch (error) {
    console.error(error);
  }
};

export const login = async (params) => {
  try {
    return await loginInstance().post(`member/signin`, qs.stringify(params));
  } catch (error) {
    console.error(error);
  }
};

export const saveClauses = async (params) => {
  const serviceUid = await setServiceUid();
  try {
    return await privateInstance().put(
      `service/${serviceUid}/member/agree`,
      qs.stringify(params)
    );
  } catch (error) {
    console.error(error);
  }
};
